import VectorSource from 'ol/source/Vector';
import Point from 'ol/geom/Point';
import WaypointFeature from './WaypointFeature';
import { WaypointIcon } from './WaypointIcon';
import { Feature } from 'ol';

export default class WaypointFeatureSource extends VectorSource<Point> {
    getFeatures() {
        return super.getFeatures().map(a => (a as WaypointFeature)).sort((a, b) => a.order - b.order)
    }

    addFeature(waypoint: WaypointFeature) { 
        super.addFeature(waypoint);
        const icon = WaypointIcon.iconFor(waypoint)
        waypoint.setStyle(icon)
    }

    addFeatures(waypoints: WaypointFeature[]) { 
        super.addFeatures(waypoints);
        waypoints.forEach( (waypoint) => waypoint.setStyle(WaypointIcon.iconFor(waypoint)) )
    }
    
    getFeatureById(id: string | number): Feature<Point> {
       return super.getFeatureById(id)!
    }
    

}